import { EventHistory } from './EventHistory';

export default EventHistory;
